<template>
  <div class="page-content">
    <headerBar :detail="{title:certDetail.certName}" type="certificate"></headerBar>
    <el-row :span='24' class="topView">
      <el-col :span="3">证书ID</el-col>
      <el-col :span="9">{{certDetail.certId}}<span class="btn" @click="copy(certDetail.certId)">复制</span></el-col>
      <el-col :span="3">生效时间</el-col>
      <el-col :span="9">{{certDetail.effectTime}}</el-col>
      <el-col :span="3">过期时间</el-col>
      <el-col :span="9">{{certDetail.expiredTime}}</el-col>
    </el-row>
    <!-- tab切换头部 -->
    <el-tabs type="border-card"   v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane label="证书信息" name="0">
         <keep-alive>
          <certificateDetailView v-if="certDetail" :certDetail="certDetail"></certificateDetailView>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="证书绑定" name="1" >
        <!-- 保证详情数据获取到得情况下，再加载组件 -->
         <keep-alive>
           <certificateBindView v-if="activeName === '1'" :certDetail="certDetail"></certificateBindView>
         </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import headerBar from '@/components/header'
import { copy } from '@/utils'
import certificateDetailView from '@/components/product_control/certificateDetailView'
import certificateBindView from '@/components/product_control/certificateBindView'
import { certInfo } from '@/api/productControl'

export default {
  components: {
    headerBar: headerBar,
    certificateDetailView,
    certificateBindView
  },
  methods: {
    copy (val) {
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    handleClick (tab) {

    },
    getCertInfo () {
      const params = this.registerCertId
      certInfo(params).then(res => {
        res = res.data
        console.log('证书详情：', res)

        // res.data.effectTime = res.data.effectTime
        //   ? dataFormat(res.data.effectTime)
        //   : ''
        // res.data.expiredTime = res.data.expiredTime
        //   ? dataFormat(res.data.expiredTime)
        //   : ''
        // res.data.registerTime = res.data.registerTime
        //   ? dataFormat(res.data.registerTime)
        //   : ''
        this.certDetail = res.data
      })
    }
  },
  data () {
    return {
      activeName: '0',
      registerCertId: this.$route.query.registerCertId,
      certDetail: ''
    }
  },
  created () {
    // console.log('certId:', this.certId)
    this.getCertInfo()
  }
}
</script>
<style lang="less" scope>
.page-content{
  .topView{
    color: rgb(136, 136, 136);
    font-size: 13px;
    line-height: 25px;
    .btn{
      color: rgb(0, 112, 204);
      margin-left: 10px;
      cursor: pointer;
    }
  }
   /deep/ .el-tabs--border-card{
    border: none;
    box-shadow:0 0 0 ;
  }
}
</style>
